export var CORRECT = 0; // фактор актуален
export var FACTOR_CHANGED = 1; // значение фактора изменено
export var FACTOR_CLOSED = 2; // фактор недоступен
export var OUTCOME_CLOSED = 3; // прием на исход закрыт
export var EVENT_CLOSED = 4; // прием на событие закрыт



// WEBPACK FOOTER //
// ./src/constants/BettingState.js